import { mapUserSession } from './map-user-session.util'

const CONTEXT_VERSION = 1

const DEFAULT_LOAD_OPTIONS = {
  clearModule: true,
  clearEntity: true,
}

const contextStore = {
  base: {},
  module: {},
  entity: {},
}

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

function sanitizeValue(value) {
  if (value === null || value === undefined)
    return

  if (typeof value === 'string') {
    const trimmedValue = value.trim()
    return trimmedValue === '' ? undefined : trimmedValue
  }

  if (Array.isArray(value)) {
    const sanitizedArray = value
      .map(item => sanitizeValue(item))
      .filter(item => item !== undefined)

    return sanitizedArray.length > 0 ? sanitizedArray : undefined
  }

  if (isPlainObject(value)) {
    const sanitizedObject = sanitizeContext(value)
    return Object.keys(sanitizedObject).length > 0 ? sanitizedObject : undefined
  }

  return value
}

export function sanitizeContext(context = {}) {
  if (!isPlainObject(context))
    return {}

  const sanitizedContext = {}

  Object.entries(context).forEach(([key, value]) => {
    const sanitizedValue = sanitizeValue(value)

    if (sanitizedValue !== undefined)
      sanitizedContext[key] = sanitizedValue
  })

  return sanitizedContext
}

export function syncAnalyticsBaseContext({ route, authStore } = {}) {
  const mappedUserSession = mapUserSession({ route, authStore })

  contextStore.base = sanitizeContext({
    context_version: CONTEXT_VERSION,
    ...mappedUserSession,
  })

  return getAnalyticsContextSnapshot()
}

export function loadAnalyticsContext(context = {}, options = {}) {
  const {
    clearModule = DEFAULT_LOAD_OPTIONS.clearModule,
    clearEntity = DEFAULT_LOAD_OPTIONS.clearEntity,
  } = options

  if (clearModule)
    contextStore.module = {}
  if (clearEntity)
    contextStore.entity = {}

  contextStore.module = {
    ...contextStore.module,
    ...sanitizeContext(context),
  }

  return getAnalyticsContextSnapshot()
}

export function enrichAnalyticsContext(
  context = {},
  { scope = 'entity', mode = 'merge' } = {},
) {
  const targetScope = scope === 'module' ? 'module' : 'entity'
  const sanitizedContext = sanitizeContext(context)

  if (mode === 'replace') {
    contextStore[targetScope] = sanitizedContext
    return getAnalyticsContextSnapshot()
  }

  contextStore[targetScope] = {
    ...contextStore[targetScope],
    ...sanitizedContext,
  }

  return getAnalyticsContextSnapshot()
}

export function clearAnalyticsContext(scope = 'all') {
  switch (scope) {
    case 'base':
      contextStore.base = {}
      break
    case 'module':
      contextStore.module = {}
      break
    case 'entity':
      contextStore.entity = {}
      break
    case 'all':
    default:
      contextStore.base = {}
      contextStore.module = {}
      contextStore.entity = {}
      break
  }
}

export function getAnalyticsContextSnapshot() {
  return sanitizeContext({
    ...contextStore.base,
    ...contextStore.module,
    ...contextStore.entity,
  })
}
